/**
 * Permission codes the control-rule screens declare an interest in
 * (`internal/core/rules/permissions.go`, design §6.1).
 *
 * `rules.control.manage` ⊗ `rules.override.read` is a **declared SoD conflict**:
 * whoever can make a rule overridable must not be the sole reviewer of the
 * overrides it then permits. Both codes are listed here because the screens read
 * them; the conflict is enforced by the role editor server-side, not by hiding a
 * link.
 *
 * `rules.override.read` is granted to `RoleAuditor` deliberately — the override
 * report is an audit artefact, and an auditor who cannot read it cannot audit.
 */

export const RULES_PERMISSIONS = {
  controlRead: 'rules.control.read',
  controlManage: 'rules.control.manage',

  reasonRead: 'rules.reason.read',
  reasonManage: 'rules.reason.manage',

  overrideRead: 'rules.override.read',

  queueRead: 'rules.queue.read',
  queueResolve: 'rules.queue.resolve',

  /** Read companies for the report and queue filters. */
  companyRead: 'org.company.read',
} as const

export type RulesPermission = (typeof RULES_PERMISSIONS)[keyof typeof RULES_PERMISSIONS]
